<script>
import debounce from 'lodash/debounce'

export default {
  name: 'FilterSearchInput',
  props: {
    value: { type: String, default: '' },
    placeholder: { type: String, default: 'Search' },
    debounceMs: { type: Number, default: 300 },
  },
  emits: ['input'],
  data() {
    return {
      localValue: this.value,
    }
  },
  computed: {
    searchText: {
      get() {
        return this.localValue
      },
      set(val) {
        this.localValue = val
        this.debouncedEmit(val)
      },
    },
  },
  watch: {
    value(newVal) {
      this.localValue = newVal
    },
  },
  created() {
    this.debouncedEmit = debounce((val) => {
      this.$emit('input', val)
    }, this.debounceMs)
  },
  beforeDestroy() {
    // Cancel any pending debounced calls on component destroy
    if (this.debouncedEmit?.cancel) {
      this.debouncedEmit.cancel()
    }
  },
}
</script>

<template>
  <div class="filter-container-search mb-4">
    <v-icon>mdi-magnify</v-icon>
    <input
      v-model="searchText"
      class="ps-2 search-input h-full filter-search-input"
      :placeholder="placeholder"
    />
  </div>
</template>

<style lang="scss" scoped>
.filter-search-input {
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  vertical-align: middle;
  outline: none;
}
</style>
